import React, { useContext, useState } from "react";
import TwoDStyles from "./twoDStyles.module.css";
import Folder from "../../../../assets/Folder.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ModalComponent } from "../../../../components";
import NewSection from "../UploadSection/UploadSection";
import Delete from "../../../../assets/delete.svg";
import DeleteModal from "../DeleteSection/DeleteModal";
import apis from "../../../../api";
import { AuthContext } from "../../../../context/AuthContext/AuthContext";

const tds = TwoDStyles;

const Two_D = (props: any) => {
  const location = useLocation();
  const { userInfo } = useContext(AuthContext);
  const { id, key } = location.state || {};
  const Navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  //Here the section key is passed as props through navigation, so that you access the section in the fileUpload component.

  const handleClick = (section_key: any) => {
    Navigate(`section`, {
      state: { section_key: section_key, project_key: key },
    });
  };
  const handleClose = () => {
    setShowModal(false);
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
  };

  const [sectionKey, setSectionKey] = useState("");
  const [projectKey, setProjectKey] = useState("");
  const [userKey, setUserKey] = useState("");

  const OpenDeleteModal = (SectionKey: any, projectKey: any, UserKey: any) => {
    setSectionKey(SectionKey);
    setProjectKey(projectKey);
    setUserKey(UserKey);
    setShowDeleteModal(true);
  };
  return (
    <>
      <div>
        <div className={tds.create_sec}>
          <div className={tds.create_text} onClick={() => setShowModal(true)}>
            New Section
          </div>
        </div>

        <div className={tds.card2}>
          {props.Two_dDesign?.map((two_d: any) => {
            console.log(">>>>>>>>>>>>>>>>>>>", two_d);
            return (
              <>
                <div className={tds.card}>
                  <div className={tds.card1}>
                    <div
                      onClick={() => handleClick(two_d?.section_key)}
                      className={tds.tempFolder}
                    >
                      <div className={tds.foldername}>
                        <img src={Folder} alt="" />
                      </div>
                      <div className={tds.foldername}>
                        {two_d?.section_name}
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        OpenDeleteModal(
                          two_d?.section_key,
                          two_d?.project_key,
                          userInfo?.user_key
                        );
                      }}
                    >
                      <img src={Delete} alt="" />
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        {/* 
        <div className={tds.card}>
          {props.Two_dDesign?.map((two_d: any) => {
            console.log(two_d?.section_name);
            return (
              <p
                className={tds.foldername}
                onClick={() => handleClick(two_d?.section_key)}
              >
                <span>
                  <img src={Folder} alt="" />
                </span>
                {two_d?.section_name}
              </p>
            );
          })}
        </div> */}
        <ModalComponent
          Component={() => (
            <NewSection
              design_template="2d"
              close={handleClose}
              project_key={key}
              getfunction={props?.getfunction}
            />
          )}
          isOpen={showModal}
          onClose={handleClose}
          title="Create New Section"
        />
        <ModalComponent
          Component={() => (
            <DeleteModal
              section={sectionKey}
              project={projectKey}
              user={userKey}
            />
          )}
          isOpen={showDeleteModal}
          onClose={handleDeleteClose}
          title="Delete section"
        />
      </div>
    </>
  );
};

export default Two_D;
